<h3>Информационное сообщение</h3>

<p>Информируем Вас о том, что с 01.07.2018 года вступают в силу изменения
    Федерального закона от 05.04.2013 N 44-ФЗ
    "О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд", в соответствии с положениями
    Федерального закона от 31.12.2017 N 504-ФЗ
    О внесении изменений в федеральный закон "О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд</p>

<p>С 01.07.2018 г. в соответствии с изменениями, внесенными Федеральным Законом от 31.12.2017 г. № 504-ФЗ в ст. 5 Федерального закона от 05.04.2013 г. № 44-ФЗ «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» (далее - Закон № 44-ФЗ) квалифицированные сертификаты ключей проверки электронных подписей создаются и выдаются удостоверяющими центрами, получившими аккредитацию на соответствие требованиям Федерального закона от 06.04.2011 г. № 63-ФЗ «Об электронной подписи»</p>


// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.html